import type { ThemePort, Theme } from '../domain/theme'

const makeSetTheme = (port: ThemePort) => (theme: Theme) => {
	port.set(theme)
}

export { makeSetTheme }
